import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Box: {
    display: 'flex',
    padding: '10px 0',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const buttonStyle = {
  gap: '8px',
  borderRadius: '8px',
  border: '1px solid var(--Primary-600, #30893C)',
  background: 'var(--Primary-600, #30893C)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: 'var(--Primary-600, #30893C)' },
};

export { useStyles, buttonStyle };
